export const DEFAULT_ERROR_MESSAGE = 'error_internal_server_error_try_again_later'
export const DEFAULT_SUCCESS_MESSAGE = 'saved'
export const DEFAULT_DEPENDENCIES_ERROR_MESSAGE = 'to_delete_this_item_remove_its_dependencies_first'
export const DEFAULT_COMFIRM_INACTIVE_MESSAGE = 'do_you_really_want_to_deactivate'
export const DEFAULT_COMFIRM_ACTIVE_MESSAGE = 'do_you_really_want_to_activate'
